module.exports = __webpack_public_path__ + "static/media/transaction-list.b420c1ce.svg";